// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import type { EventsWeeklySummaryResp, EventsPerUserResp } from '@evolvemep/api-ts';
import { Card, Flex, Stack } from '@mantine/core';

import { isNil } from 'helpers/isNotNil';

import { SummaryCard } from '../components/SummaryCard';
import type { AnalyticsViewProps } from '../types';
import { EventsByDateChart } from './charts/EventsByDateChart';
import { EventsPerUserChart } from './charts/EventsPerUserChart';
import { NumberOfEventsChart } from './charts/NumberOfEventsChart';

export const FeatureAnalysisView = (props: AnalyticsViewProps) => {
  const [eventData, setEventData] = useState<EventsWeeklySummaryResp>();
  const [userEventData, setUserEventData] = useState<EventsPerUserResp>();

  const { averageEventsPerWeek, totalEvents } = eventData ?? {};
  const { avgEventsPerUser } = userEventData ?? {};

  return (
    <Flex h="100%" gap="xs" style={{ overflow: 'hidden' }}>
      <Stack flex={5} pr="xs" style={{ overflowY: 'scroll' }}>
        <Card withBorder flex="1 0 auto">
          <EventsByDateChart onDataRealized={setEventData} {...props} />
        </Card>
        <Card withBorder flex="1 0 auto">
          <NumberOfEventsChart {...props} />
        </Card>
        <Card withBorder flex="1 0 auto">
          <EventsPerUserChart onDataRealized={setUserEventData} {...props} />
        </Card>
      </Stack>
      <Stack flex={1} gap="sm">
        <SummaryCard title="Total Events" value={totalEvents} loading={isNil(eventData)} />
        <SummaryCard title="Avg. Events Per Week" value={averageEventsPerWeek} loading={isNil(eventData)} />
        <SummaryCard title="Avg. Events Per User" value={avgEventsPerUser} loading={isNil(userEventData)} />
      </Stack>
    </Flex>
  );
};
